import bankStyles from '../../assets/css/banks.module.css';
import NoticeIcon from '../svgs/NoticeIcon';
import { BanksLoadingSkeleton } from './BankSkeleton';
import { BankPage } from './BankPage';
import { Bank, BanksPage } from '../../services/interfaces/bank.interface';

export type Page = BanksPage | undefined;

interface BankListProps {
	pages: Array<Page> | undefined;
	isLoadingMore?: boolean;
	isEmpty?: boolean;
	nextPageSize?: number | undefined;
	onBankSelect(bank: Bank): void;
}

const BankPages = ({ pages, isEmpty = false, isLoadingMore = false, nextPageSize, onBankSelect }: BankListProps) => {
	if (isEmpty === true) return <EmptyResult />;

	if (!pages) return <BanksLoadingSkeleton count={4} />;

	const _pages = pages ? ([] as Array<Page>).concat(...pages) : [];
	return (
		<div className="bank-loading-skeletons" style={{ width: '100%' }}>
			{_pages.map((page, index) => (
				<BankPage page={page} key={index} onBankSelect={onBankSelect} />
			))}
			{isLoadingMore && (
				<BankPage page={undefined} skeletonCount={nextPageSize} key="skeletons-page" onBankSelect={() => {}} />
			)}
		</div>
	);
};

export default BankPages;

const EmptyResult = () => {
	return (
		<div className={bankStyles['empty-result-container']}>
			<div className={bankStyles['empty-results']}>
				<div className={bankStyles['empty-results-icon']}>
					<NoticeIcon style={{ opacity: 0.8 }} />
				</div>
				<div className={bankStyles['empty-results-text']}>
					<span>No results.</span>
				</div>
			</div>
		</div>
	);
};
